var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.288 2.28478C29.4433 2.28478 32.0026 15.5909 32.0026 32H36.5722C36.5722 14.3282 31.9686 0 26.288 0C23.0569 0 20.1735 4.30553 18.2992 11.0396C16.4013 4.30553 13.5178 0 10.2867 0C4.60616 0 0 14.3282 0 32H4.57218C4.57218 15.5909 7.13144 2.28478 10.2867 2.28478C13.442 2.28478 16.0013 14.5714 16.0013 29.7152H20.5735C20.5735 14.5661 23.1327 2.28478 26.288 2.28478Z","fill":"#FFBC0D"}));
}

Logo.defaultProps = {"width":"37","height":"32","viewBox":"0 0 37 32","fill":"none"};

module.exports = Logo;

Logo.default = Logo;
